<div class="modal-content">
  <div class="modal-header">
    <h2 class="modal-title">{{ modalTitle }}</h2>
  </div>

  <form [formGroup]="formGroup">
    <div class="modal-body">
      <div class="field">
        <gains-input label="Project Name" type="text" placeholder="New Project" formControlName="projectName" [required]="true" [maxlength]="nameMaxLength" />
        <span class="field-error" *ngIf="isNameTooLong">Keep the name to {{ nameMaxLength }} characters.</span>
      </div>
      <div class="field">
        <gains-text-area label="Project Description (Optional)" placeholder="Project Description" formControlName="projectDescription"></gains-text-area>
      </div>
      <div class="field">
        <gains-select label="Who Can Access" formControlName="projectAccess" [items]="accessOptions" [required]="true"> </gains-select>
      </div>
      <div class="field">
        <gains-select
          class="color-select"
          label="Project Color"
          formControlName="projectColor"
          [items]="colorOptions"
          [required]="true"
          [style.--selected-color]="selectedColorCode"
          (mousedown)="enableColorDropdownScope()"
        >
        </gains-select>
      </div>
    </div>
  </form>

  <div class="modal-footer">
    <button class="footer-btns" nz-button nzType="default" (click)="onCancel()">Cancel</button>
    <button class="footer-btns" nz-button nzType="primary" [disabled]="!isFormSubmittable" (click)="onSave()">Save</button>
  </div>
</div>
